import axios from 'axios'
import store from '@/store/index.js'
import baseURL from './baseUrl'
import { Message } from 'element-ui'
const http = {}

axios.defaults.headers.post["Content-Type"] = "application/json";

var instance = axios.create({
	// timeout: 20000,
	baseURL,
	validateStatus(status) {
		switch (status) {
			case 400:
				Message.error('请求出错')
				break
			case 401:
				Message.warning({
					message: '授权失败，请重新登录'
				})
				store.commit('LOGIN_OUT')
				setTimeout(() => {
					window.location.reload()
				}, 1000)
				return
			case 403:
				Message.warning({
					message: '拒绝访问'
				})
				break
			case 404:
				Message.warning({
					message: '请求错误,未找到该资源'
				})
				break
			case 500:
				Message.warning({
					message: '服务端错误'
				})
				break
		}
		return status >= 200 && status < 300
	}
})

// 添加请求拦截器
instance.interceptors.request.use(
	function (config) {
		// 请求头添加token
		// if (store.state.UserToken) {
		// 	config.headers.Authorization = `store.state.UserToken`
		// }
		// if(localStorage.getItem('ms_username')){
		// 	document.cookie = 'ms_username='+ localStorage.getItem('ms_username');
		// 	localStorage.clear('ms_username')
		// }
		return config
	},
	function (error) {
		return Promise.reject(error)
	}
)

// 响应拦截器即异常处理
instance.interceptors.response.use(
	response => {
		// console.log('response',response)
		return response
	},
	err => {
		if (err && err.response) {
		} else {
			err.message = '连接服务器失败'
		}
		// Message.error({
		//     message: err.message
		// })
		return Promise.reject(err.response)
	}
)

http.get = function (url, options) {
	return new Promise((resolve, reject) => {
		instance
			.get(url, options)
			.then(response => {
				response = response.data;
				if (response.code === 0) {
					resolve(response)
				} else {
					// codo:-1: 登录过期;
					if(response.code === -1){
						// Message.error({
						// 	message: "登录过期，请重新登录！"
						// }) 
						Message.error({
							message: response.data.messageInfo
						}) 
						store.commit('LOGIN_OUT')
						setTimeout(() => {
							window.location.reload()
						}, 1000)
					} 
					// codo:1007: 权限不足;
					else if(response.code === 1007){
						reject(response.message)
						// Message.error({
						// 	message: "权限不足"
						// }) 
						// store.commit('LOGIN_OUT')
						// setTimeout(() => {
						// 	window.location.reload()
						// }, 1000)
					} 
					else {
						Message.error({
							message: response.data ? response.data.messageInfo : response.message
						})
						reject(response.data ? response.data.messageInfo : response.message || response.message)
					}
				}
			})
			.catch(e => {
				console.log(e)
			})
	})
}

http.post = function (url, data, options) {
	return new Promise((resolve, reject) => {
		instance
			.post(url, data, options)
			.then(response => {
				response = response.data;
				if (response.code === 0) {
					resolve(response)
				} else {
					// codo:-1: 登录过期;
					if(response.code === -1){
						// Message.error({
						// 	message: "登录过期，请重新登录！"
						// }) 
						Message.error({
							message: response.data.messageInfo
						}) 
						store.commit('LOGIN_OUT')
						setTimeout(() => {
							window.location.reload()
						}, 1000)
					} 
					// codo:-1: 权限不足;
					else if(response.code === 1007){
						reject(response.message)
						// Message.error({
						// 	message: "权限不足"
						// }) 
						// store.commit('LOGIN_OUT')
						// setTimeout(() => {
						// 	window.location.reload()
						// }, 1000)
					// 直接返回，没有code;	
					} else if(!response.code){
						resolve(response)
					}
					else {
						Message.error({
							message: response.data ? response.data.messageInfo : response.message
						})
						reject({msg: response.data ? response.data.messageInfo : response.message, data: response.data, code: response.code})
					}
				}
			})
			.catch(e => {
				console.log(e)
			})
	})
}

http.postBlob = function (url, data, options) {
	return new Promise((resolve, reject) => {
		instance
			.post(url, data, {
				responseType:'blob'
			})
			.then(response => {
				if (response) {
					resolve(response)
				} else {
					Message.error({
						message: response.data ? response.data.messageInfo : response.message
					})
					reject(response.data ? response.data.messageInfo : response.message)
				}
			})
			.catch(e => {
				console.log(e)
			})
	})
}

export default http
